/**
 * @author：
 * @update：
 * @description：
 **/
import {evaluateGet,evaluateDetails,evaluateDelete} from '@/api/evaluate'
import download from "downloadjs";
import {fileEcho} from "@/api/url";
import CusPagination from "@/components/cusPagination";
import {userInfoHeaderHttp} from "@/config/config"
export default {
    components: {
        CusPagination,
    },
    data() {
        return {
            detailId:'',
            tableData: {
                orderEvaluation:{
                    store:{},
                    order:{
                        status:''
                    }
                },
                sku:{
                    specifications:[
                        {
                            name:''
                        }
                    ]
                },
                spu:{
                    images:[
                        {
                            location:''
                        }
                    ],
                    store:{
                        name:''
                    }
                },
                userInfo:{
                    nickname:''
                }
            },
            tableDataLoc:fileEcho,
            userHead:userInfoHeaderHttp,
        };
    },
    // 自定义方法
    methods: {
        //获取数据
        getList() {
            this.$ajax.get(evaluateDetails(this.detailId),).then((res) => {
                if (res.status === 200) {// 成功了
                    this.tableData = res.data;
                }
            }, (err) => {
                console.log(err);
            })
        },
        //删除
        delClick(){
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$ajax.post(evaluateDelete(this.detailId),{
                }).then((res) => {
                    if (res.status === 200) {// 成功了
                        this.getList();
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.$router.push({path: '/evaluate'});
                    }
                }, (err) => {
                    console.log(err);
                })

            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });

        },
        closeClick(){
            this.$router.push({path: '/evaluate'});
        }
    },
    // 数据观察监听
    watch: {

    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {
        if (this.$route.query.id != undefined) {
            this.detailId = window.atob(this.$route.query.id);//详情的id
            this.getList();
        }
    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
